var exports = {
  "X": "x4c3adb35--994c41--pseudolink",
};

module.exports = exports;
